import { createSlice } from "@reduxjs/toolkit";

import {
  updateProfile,
  addUserPofile,
  checkUniqueAadharAction,
  checkUniquePanAction,
  checkUniquePassportAction,
  checkUniqueUanAction,
} from "@/redux/usersProfile/actions";
import { initialState } from "@/redux/usersProfile/initialState";
import { usersProfileReducer } from "@/redux/usersProfile/reducer";
import type { UsersProfileTypes } from "@/redux/usersProfile/usersProfileTypes";

export const usersProfileSlice = createSlice({
  name: "usersProfils",
  initialState,
  reducers: usersProfileReducer,

  extraReducers: (builder) => {
    builder.addCase(updateProfile.pending, (state: UsersProfileTypes) => ({
      ...state,
      fetching: true,
    }));

    builder.addCase(
      updateProfile.fulfilled,
      (state: UsersProfileTypes, { payload }) => {
        const { success, message, result = {}, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            result,
            success,
          };
        }
        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
          message,
        };
      }
    );

    builder.addCase(
      updateProfile.rejected,
      (state: UsersProfileTypes, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(addUserPofile.pending, (state: UsersProfileTypes) => ({
      ...state,
      fetching: true,
    }));

    builder.addCase(
      addUserPofile.fulfilled,
      (state: UsersProfileTypes, { payload }) => {
        const { success, message, result = {}, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            result,
            success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
          message,
        };
      }
    );

    builder.addCase(
      addUserPofile.rejected,
      (state: UsersProfileTypes, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      checkUniqueAadharAction.pending,
      (state: UsersProfileTypes) => ({
        ...state,
        aadhaarFetching: true,
      })
    );

    builder.addCase(
      checkUniqueAadharAction.fulfilled,
      (state: UsersProfileTypes, { payload }) => {
        const {
          success,
          message,
          result = {},
          status_code,
          is_duplicate,
        } = payload;

        if (success === 0) {
          return {
            ...state,
            aadhaarFetching: false,
            aadhaarError: message,
            aadhaarSuccess: success,
            isAadhaarNo: is_duplicate,
            statusCodeAadhaar: status_code,
          };
        }
        return {
          ...state,
          aadhaarFetching: false,
          aadhaarSuccess: success,
          // fetching: false,

          aadhaarMessage: message,
          isAadhaarNo: is_duplicate,
          statusCodeAadhaar: status_code,
        };
      }
    );

    builder.addCase(
      checkUniqueAadharAction.rejected,
      (state: UsersProfileTypes, { error }) => ({
        ...state,
        panFetching: false,

        //  aadhaarError:  error?.message,
        //  panSuccess:0,
        success: 0,

        error: error.message ?? null,
      })
    );

    builder.addCase(
      checkUniquePanAction.pending,
      (state: UsersProfileTypes) => ({
        ...state,
        panFetching: true,
      })
    );

    builder.addCase(
      checkUniquePanAction.fulfilled,
      (state: UsersProfileTypes, { payload }) => {
        const {
          success,
          message,
          result = {},
          status_code,
          is_duplicate,
        } = payload;

        if (success === 0) {
          return {
            ...state,
            panFetching: false,
            panError: message,
            panSuccess: success,
            isPanNo: is_duplicate,
            statusCodePan: status_code,
          };
        }
        return {
          ...state,
          panFetching: false,
          panSuccess: success,
          // fetching: false,
          statusCodePan: status_code,
          panMessage: message,
          isPanNo: is_duplicate,
        };
      }
    );

    builder.addCase(
      checkUniquePanAction.rejected,
      (state: UsersProfileTypes, { error }) => ({
        ...state,
        panFetching: false,

        //  panError:  error?.message,
        // panSuccess: 0,
        success: 0,

        error: error.message ?? null,
      })
    );

    builder.addCase(
      checkUniquePassportAction.pending,
      (state: UsersProfileTypes) => ({
        ...state,
        passportFetching: true,
      })
    );

    builder.addCase(
      checkUniquePassportAction.fulfilled,
      (state: UsersProfileTypes, { payload }) => {
        const {
          success,
          message,
          result = {},
          status_code,
          is_duplicate,
        } = payload;

        if (success === 0) {
          return {
            ...state,
            passportFetching: false,
            passportError: message,
            passportSuccess: success,
            isPassportNo: is_duplicate,
            statusCodePassport: status_code,
          };
        }
        return {
          ...state,
          passportFetching: false,
          passportMessage: message,
          passportSuccess: success,
          isPassportNo: is_duplicate,
          statusCodePassport: status_code,
        };
      }
    );

    builder.addCase(
      checkUniquePassportAction.rejected,
      (state: UsersProfileTypes, { error }) => ({
        ...state,
        passportFetching: false,
        success: 0,
        error: error.message ?? null,
      })
    );

    builder.addCase(
      checkUniqueUanAction.pending,
      (state: UsersProfileTypes) => ({
        ...state,
        uanFetching: true,
      })
    );

    builder.addCase(
      checkUniqueUanAction.fulfilled,
      (state: UsersProfileTypes, { payload }) => {
        const {
          success,
          message,
          result = {},
          status_code,
          is_duplicate,
        } = payload;

        if (success === 0) {
          return {
            ...state,
            uanFetching: false,
            uanError: message,
            uanSuccess: success,
            isUanNo: is_duplicate,
            statusCodeUan: status_code,
          };
        }
        return {
          ...state,
          uanFetching: false,
          uanMessage: message,
          uanSuccess: success,
          isUanNo: is_duplicate,
          statusCodeUan: status_code,
        };
      }
    );

    builder.addCase(
      checkUniqueUanAction.rejected,
      (state: UsersProfileTypes, { error }) => ({
        ...state,
        uanFetching: false,
        success: 0,
        error: error.message ?? null,
      })
    );
  },
});

export const {
  resetError: resetUsersProfileError,
  resetSuccess: resetUsersProfileSuccess,
  resetUsersProfileMessage,
  resetUsersProfileFetching,
  resetPanMessage,
  resetPanError,
  resetStatusCodePan,
  resetAadhaarMessage,
  resetAadhaarError,
  resetStatusCodeAadhaar,
  resetPanSuccess,
  resetAaddharSuccess,
  resetPassportError,
  resetPassportMessage,
  resetPassportSuccess,
  resetStatusCodePassport,
  resetUanError,
  resetUanMessage,
  resetUanSuccess,
  resetStatusCodeUan,
} = usersProfileSlice.actions;
